import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444156e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold mb-5" }
const _hoisted_3 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_4 = { class: "w-max-content col-lg-2" }
const _hoisted_5 = { class: "col-lg-10" }
const _hoisted_6 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_7 = { class: "w-max-content col-lg-2" }
const _hoisted_8 = { class: "col-lg-10" }
const _hoisted_9 = {
  key: 0,
  class: "ms-1"
}
const _hoisted_10 = {
  key: 1,
  class: "ms-1"
}
const _hoisted_11 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_12 = { class: "w-max-content col-lg-2" }
const _hoisted_13 = { class: "col-lg-10" }
const _hoisted_14 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_15 = { class: "w-max-content col-lg-2" }
const _hoisted_16 = { class: "col-lg-10" }
const _hoisted_17 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_18 = { class: "w-max-content col-lg-2" }
const _hoisted_19 = { class: "col-lg-10 text-break" }
const _hoisted_20 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_21 = { class: "w-max-content col-lg-2" }
const _hoisted_22 = { class: "col-lg-10" }
const _hoisted_23 = {
  key: 0,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_24 = { class: "w-max-content col-lg-2" }
const _hoisted_25 = { class: "col-lg-10 text-break" }
const _hoisted_26 = {
  key: 1,
  class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_27 = { class: "w-max-content col-lg-2" }
const _hoisted_28 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_29 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_30 = { class: "w-max-content col-lg-2" }
const _hoisted_31 = { class: "col-lg-10 text-break" }
const _hoisted_32 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_33 = { class: "w-max-content col-lg-2" }
const _hoisted_34 = { class: "col-lg-10 text-break" }
const _hoisted_35 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_36 = { class: "w-max-content col-lg-2" }
const _hoisted_37 = {
  key: 0,
  class: "col-lg-10 text-break"
}
const _hoisted_38 = { class: "mb-4 mx-2" }
const _hoisted_39 = { class: "border-bottom row mx-4 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_40 = { class: "w-max-content col-lg-2" }
const _hoisted_41 = { class: "col-lg-10" }
const _hoisted_42 = { class: "border-bottom row mx-4 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_43 = { class: "w-max-content col-lg-2" }
const _hoisted_44 = { class: "col-lg-10" }
const _hoisted_45 = { class: "border-bottom row mx-4 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_46 = { class: "w-max-content col-lg-2" }
const _hoisted_47 = {
  key: 0,
  class: "col-lg-10"
}
const _hoisted_48 = { class: "mb-4 mx-2" }
const _hoisted_49 = { class: "border-bottom row mx-4 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_50 = { class: "w-max-content col-lg-2" }
const _hoisted_51 = { class: "col-lg-10 d-flex align-items-center" }
const _hoisted_52 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_53 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_54 = {
  key: 2,
  class: "mt-1"
}
const _hoisted_55 = {
  key: 3,
  class: "mt-1"
}
const _hoisted_56 = { class: "border-bottom row mx-4 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_57 = { class: "w-max-content col-lg-2" }
const _hoisted_58 = { class: "col-lg-10" }
const _hoisted_59 = { class: "d-flex justify-content-center" }

import { computed, PropType, ref } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'

import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { ConvertFromLocalTime } from '@/constants/datepicker.ts'
import { translate } from '@/languages/i18n'

import { PREFECTURES } from '@/constants/index'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<{
    management_no: string | number
    family_name: string
    given_name: string
    family_name_kana: string
    given_name_kana: string
    display_name: string
    email: string
    zipcode_1: string
    zipcode_2: string
    zipcode_judgment: boolean
    zipcode_foreign: string
    address_1: string
    address_2: string
    phone_number_1: string
    phone_number_2: string
    phone_number_3: string
    birthday: string
    institution: string
    job_type_parent: string
    job_type_child: string
    enrollment_start_period: string
    status: string
  }>,
  invitedCommunityManagement: Object as PropType<{
    display_name: string
    family_name: string
    given_name: string
    management_no: string
    user_type: number
  }>,
},
  setup(__props) {

const router = useRouter()



const backToList = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus?management_no=desc`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('basicInformation')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_unref(translate)('managementNo')), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.data?.management_no), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(translate)('nameKanji')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(__props.data?.family_name + ' ' + __props.data?.given_name), 1),
        (__props.data?.status === 'leave')
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(translate)('SO10user30')), 1))
          : _createCommentVNode("", true),
        (__props.data?.status === 'available')
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(translate)('OE12pause')), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)('nameKatakana')), 1),
      _createElementVNode("div", _hoisted_13, _toDisplayString(__props.data?.family_name_kana + ' ' + __props.data?.given_name_kana), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('nickName')), 1),
      _createElementVNode("div", _hoisted_16, _toDisplayString(__props.data?.display_name), 1)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(translate)('email')), 1),
      _createElementVNode("div", _hoisted_19, _toDisplayString(__props.data?.email), 1)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("label", _hoisted_21, _toDisplayString(_unref(translate)('dateOfBirth')), 1),
      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(dayjs)(__props.data?.birthday).format('YYYY/MM/DD')), 1)
    ]),
    (__props.data?.zipcode_judgment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(translate)('zipcode')), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(__props.data?.zipcode_foreign), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(translate)('zipcode')), 1),
          (__props.data?.zipcode_1 && __props.data?.zipcode_2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(__props.data?.zipcode_1) + "-" + _toDisplayString(__props.data?.zipcode_2), 1))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("label", _hoisted_30, _toDisplayString(_unref(translate)('address1')), 1),
      _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(PREFECTURES).find((item) => item.id == __props.data.address_1)?.name), 1)
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(translate)('address2')), 1),
      _createElementVNode("div", _hoisted_34, _toDisplayString(__props.data?.address_2), 1)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("label", _hoisted_36, _toDisplayString(_unref(translate)('PhoneNumber')), 1),
      (__props.data?.phone_number_1 && __props.data?.phone_number_2 && __props.data?.phone_number_3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(__props.data?.phone_number_1) + "-" + _toDisplayString(__props.data?.phone_number_2) + "-" + _toDisplayString(__props.data?.phone_number_3), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_38, _toDisplayString(_unref(translate)('currentPositionInfo')), 1),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("label", _hoisted_40, _toDisplayString(_unref(translate)('affiliation')), 1),
      _createElementVNode("div", _hoisted_41, _toDisplayString(__props.data?.institution), 1)
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(translate)('occupation')), 1),
      _createElementVNode("div", _hoisted_44, _toDisplayString(__props.data?.job_type_parent + ' ' + __props.data?.job_type_child), 1)
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("label", _hoisted_46, _toDisplayString(_unref(translate)('affiliationPeriod')), 1),
      (__props.data?.enrollment_start_period)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_unref(dayjs)(__props.data?.enrollment_start_period).format('YYYY/M') + ' ' + _unref(translate)('SA20from') + ' ' + _unref(translate)('CI40current')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(translate)('registrationRoute')), 1),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("label", _hoisted_50, _toDisplayString(_unref(translate)('registrationRoute')), 1),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(UserAliasIcon, {
          userType: __props.invitedCommunityManagement?.user_type
        }, null, 8, ["userType"]),
        ([1, 2].includes(__props.invitedCommunityManagement?.user_type))
          ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(__props.invitedCommunityManagement?.management_no + ' ' + __props.invitedCommunityManagement?.family_name + ' ' + __props.invitedCommunityManagement?.given_name), 1))
          : _createCommentVNode("", true),
        ([1, 2].includes(__props.invitedCommunityManagement?.user_type) && __props.invitedCommunityManagement?.display_name)
          ? (_openBlock(), _createElementBlock("span", _hoisted_53, " （" + _toDisplayString(__props.invitedCommunityManagement?.display_name) + "） ", 1))
          : _createCommentVNode("", true),
        (__props.invitedCommunityManagement?.user_type === 3)
          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(__props.invitedCommunityManagement?.display_name), 1))
          : _createCommentVNode("", true),
        (__props.invitedCommunityManagement?.user_type !== 0 && __props.data?.invited_route !== 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(__props.data?.invited_route_name), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_56, [
      _createElementVNode("label", _hoisted_57, _toDisplayString(_unref(translate)('applicationTime')), 1),
      _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(ConvertFromLocalTime)(__props.data?.alumni_community_information_created_at)), 1)
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        onClick: backToList
      }, null, 8, ["title"])
    ])
  ]))
}
}

})